import { CRUD } from "@/shared/components";
import {
  PlatformsListQuery,
  PlatformShowQuery,
  DeletePlatformsMutation,
  RestorePlatformsMutation,
} from "@/admin/entities/platforms";
import { usePlatformsManagement, type PlatformRow } from "../model";
import * as PlatformsSchemas from "../model/schemas";
import { PlatformShowComponent } from "@/admin/features/platforms";

/**
 * UI компонент для управления платформами
 * Чистый презентационный компонент, использует логику из model слоя
 * GraphQL операции импортирует из platform entity
 */
export function Platforms() {
  const { columns, mobileColumns, mapColumns, getTableData, texts } =
    usePlatformsManagement();

  return (
    <CRUD<PlatformRow>
      listQuery={PlatformsListQuery}
      getTableData={getTableData}
      mapColumns={mapColumns}
      columns={columns}
      filterSchema={PlatformsSchemas.filterSchema}
      createSchema={PlatformsSchemas.createSchema}
      editSchema={PlatformsSchemas.createEditSchema(PlatformShowComponent)}
      editQuery={PlatformShowQuery}
      deleteMutation={DeletePlatformsMutation}
      restoreMutation={RestorePlatformsMutation}
      texts={texts}
      persistFilters
      useMobileView
      mobileColumns={mobileColumns}
    />
  );
}
